import React, { useCallback, useEffect, useRef, useState } from 'react';
import { StyledDiv, StyledSpan } from '../../Theme/CommonStyled';
import BrandContainerWithLogo from '../Common/BrandContainerWithLogo';
import {
  StyledCountDown,
  StyledLoginContainer,
  StyledMobileInputContainer,
  StyledPhoneNumberContainer,
  StyledResendCode
} from './style';
import MobileInput from '../Common/MobileInput';
import LoginButton from '../Common/LoginButton';
import useAccountStore from '../../Store/Account';
import useLandingStore from '../../Store/Landing';
import OtpInput from '../Common/OtpInput';
import { useNavigate } from 'react-router';
import Lottie from 'lottie-react';
import ThreeDotsLoading from '../../Assets/images/three-dots-loading.json';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [phoneNumber, setPhoneNumber] = useState('');
  const [isPhoneEntered, setIsPhoneEntered] = useState(false);
  const [otpCode, setOtpCode] = useState('');
  const [countDown, setCountDown] = useState(59);
  const [phoneNumberError, setPhoneNumberError] = useState(false);

  const smsUrl = useLandingStore((state) => state.smsUrl);
  const getOtpCodeAction = useAccountStore((state) => state.getOtpCodeAction);
  const otpRequestLoading = useAccountStore((state) => state.otpRequestLoading);
  const otpRequestError = useAccountStore((state) => state.otpRequestError);
  const sendOtpCodeAction = useAccountStore((state) => state.sendOtpCodeAction);
  const sendOtpLoading = useAccountStore((state) => state.sendOtpLoading);
  const sendOtpError = useAccountStore((state) => state.sendOtpError);
  const resendOtpCodeAction = useAccountStore(
    (state) => state.resendOtpCodeAction
  );
  const landingData = useLandingStore((state) => state.landingData);

  useEffect(() => {
    !landingData?.branchId && navigate(smsUrl);
  }, []);

  const decrementTimer = useCallback(() => {
    setCountDown((countDown) => countDown - 1);
  }, []);

  useEffect(() => {
    if (countDown <= 0) {
      return;
    }
    const countDownHandler =
      isPhoneEntered && setInterval(decrementTimer, 1000);
    return () => clearInterval(countDownHandler);
  }, [decrementTimer, countDown, isPhoneEntered]);

  useEffect(() => {
    sendOtpError && setCountDown(0);
  }, [sendOtpError]);

  const OnPhoneNumberSubmit = async (e): Promise<void> => {
    e.preventDefault();
    const res = await getOtpCodeAction(phoneNumber, landingData?.branchId);
    res && setIsPhoneEntered(true);
  };

  const onSendOtpCode = (e) => {
    e.preventDefault();
    sendOtpCodeAction(phoneNumber, otpCode, landingData?.uniqueId, navigate);
  };

  useEffect(() => {
    otpCode.length === 5 &&
      sendOtpCodeAction(phoneNumber, otpCode, landingData?.uniqueId, navigate);
  }, [otpCode]);

  useEffect(() => {
    setPhoneNumberError(
      phoneNumber.length === 11 && !/^09\d{9}$/.test(phoneNumber)
    );
  }, [phoneNumber]);

  useEffect(() => {
    isPhoneEntered && setOtpCode('');
  }, [isPhoneEntered]);

  const threeDotLoadingAnimation = (
    <StyledDiv width={17} m="auto">
      <Lottie animationData={ThreeDotsLoading} loop={true} />
    </StyledDiv>
  );

  return (
    <StyledLoginContainer>
      <BrandContainerWithLogo
        logo={landingData?.logoUrl}
        brandName={landingData?.brandName}
        logoStyle={{ width: '110px !important', height: '110px !important' }}
        brandNameStyle={{ mb: '0 !important' }}
        noBackground={true}
      />
      {!isPhoneEntered ? (
        <form onSubmit={OnPhoneNumberSubmit}>
          <StyledMobileInputContainer>
            <MobileInput
              value={phoneNumber}
              onChange={setPhoneNumber}
              error={
                phoneNumber.length === 11 && !/^09\d{9}$/.test(phoneNumber)
              }
              errorMessage={t('login.phoneNumberIsIncorrect')}
            />
          </StyledMobileInputContainer>
          <StyledDiv width="100%" display="flex" justifyContent="center">
            <LoginButton
              width="320px"
              disabled={phoneNumber.length < 11 || phoneNumberError}
              errorStatus={phoneNumberError}
              loading={otpRequestLoading}>
              دریافت کد
            </LoginButton>
          </StyledDiv>
        </form>
      ) : (
        <>
          <form onSubmit={onSendOtpCode}>
            <StyledPhoneNumberContainer>
              <StyledSpan
                fontSize={6}
                fontWeight={500}
                color="normalText"
                mb={5}>
                : شماره تلفن
              </StyledSpan>
              <StyledDiv
                fontSize={10}
                color="secondaryGreen"
                letterSpacing="0.3rem">
                {phoneNumber || '-'}
              </StyledDiv>
            </StyledPhoneNumberContainer>
            <StyledDiv>
              {sendOtpLoading ? (
                <StyledDiv mt={countDown === 0 ? '158px' : 0} width="320px">
                  {threeDotLoadingAnimation}
                </StyledDiv>
              ) : (
                <StyledDiv width={280}>
                  <OtpInput
                    dataValue={otpCode}
                    onChange={setOtpCode}
                    error={sendOtpError && otpCode.length === 5}
                    errorMessage={t('login.otpErrorMessage')}
                  />
                </StyledDiv>
              )}
            </StyledDiv>
            {countDown > 0 && (
              <>
                <StyledCountDown>
                  دریافت مجدد کد:
                  <StyledSpan
                    mx={5}
                    color="secondaryGreen"
                    fontFamily="IRANSans">
                    00:{countDown} ثانیه
                  </StyledSpan>
                </StyledCountDown>
                <StyledDiv
                  textAlign="center"
                  fontSize={6}
                  color="normalText"
                  cursor="pointer"
                  onClick={(): void => {
                    setCountDown(59);
                    setIsPhoneEntered(false);
                  }}>
                  تغییر شماره موبایل
                </StyledDiv>
              </>
            )}
            {countDown === 0 && (
              <StyledResendCode
                mt={sendOtpError && otpCode.length === 5 ? '0 !important' : ''}>
                <StyledDiv
                  onClick={(): void => {
                    resendOtpCodeAction(phoneNumber, landingData?.branchId);
                    setCountDown(59);
                    setOtpCode('');
                  }}>
                  دریافت مجدد کد
                </StyledDiv>
                <StyledDiv height={10} width={1} bg="secondaryText" mx={9} />
                <StyledDiv
                  onClick={(): void => {
                    setCountDown(59);
                    setIsPhoneEntered(false);
                  }}>
                  تغییر شماره موبایل
                </StyledDiv>
              </StyledResendCode>
            )}
          </form>
        </>
      )}
    </StyledLoginContainer>
  );
};

export default Login;
